<template>
    <div
        component="VoicesListItem"
        :class="[
            { disabled: actor.character_id !== null },
            { isSmallScreen: getIsSmallScreen },
            { isSmallerScreen: getIsSmallerScreen },
            { closed: !canEditProject },
        ]"
        :voice="actor.id"
    >
        <div class="number" :style="getVoiceStyle">
            {{ actor.index }}
        </div>
        <div class="name" :title="actor.meno_priezvisko">
            <span class="text">{{ actor.meno_priezvisko }}</span>
        </div>

        <div class="actions">
            <div class="icon face" v-if="actor.hasPhotos">account_circle</div>
            <mp3-player
                :state="!actor.mp3_biblia ? 'error' : ''"
                class="sample"
                :file="getSampleMp3Url(actor.mp3_biblia)"
                :size="getIsSmallerScreen ? 'smaller' : 'small'"
                :visualizer="'project'"
            ></mp3-player>

            <mp3-player
                :state="!actor.mp3 ? 'error' : ''"
                class="sample"
                :file="getSampleMp3Url(actor.mp3)"
                :size="getIsSmallerScreen ? 'smaller' : 'small'"
                :visualizer="'project'"
            ></mp3-player>

            <btn
                :icon="'info'"
                :size="getIsSmallerScreen ? 'iconSmall' : 'icon'"
                color="transparent"
                @click="openActorDetail(actor)"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import draggable from 'vuedraggable';
import Mp3Player from '@/components/.global/Mp3Player.vue';

export default {
    name: 'VoicesListItem',

    components: {
        draggable,
        Mp3Player,
    },

    props: {
        actor: {
            type: Object,
            required: true,
        },
    },

    methods: {
        ...mapActions(['projectAddActorToBlacklist', 'projectRemoveActorFromBlacklist', 'openActorDetail']),
        ...mapMutations(['setProjectGalleryDialog', 'setProjectActorDialog']),
    },

    computed: {
        ...mapGetters([
            'getSampleMp3Url',
            'getColorById',
            'getProjectCharacterById',
            'getProject',
            'getIsSmallScreen',
            'getIsSmallerScreen',
            'canEditProject',
        ]),

        voiceColor() {
            if (!this.actor.character_id) return;
            if (this.actor.character_id === -1) return 'rgba(0,0,0,0.4)';

            const character = this.getProjectCharacterById(this.actor.character_id);
            return character ? this.getColorById(character.farba) : 'transparent';
        },

        getVoiceStyle() {
            return !this.actor.character_id ? '' : 'background: ' + this.voiceColor + '!important';
        },
    },
};
</script>

<style lang="less">
@import '~@variables';

[component='VoicesListItem'] {
    .flex-row;
    position: relative;
    overflow: hidden;
    border-bottom: 1px solid fade(white, 40%);
    padding: 0 8px 0 0;
    min-height: 40px;
    height: 40px;
    cursor: move;

    &.closed {
        cursor: default;
    }

    &.disabled {
        cursor: default;

        &:hover {
            &:before {
                opacity: 0.2;
            }
        }
    }

    &.isSmallerScreen {
        min-height: 33px;
        height: 33px;
        padding: 0 5px 0 0;

        .name {
            font-size: 13px;
        }
    }

    &:before {
        .fullFillBground;
        background-color: white;
        opacity: 0.2;
        pointer-events: none;
        transition: 0.3s;
    }

    &:hover {
        &:before {
            opacity: 0;
        }
    }

    .number {
        .flex-center;
        font-size: 11px;
        font-weight: bold;
        border-right: 1px solid fade(white, 30%);
        min-width: 25px;
        height: 100%;
        background-color: fade(white, 60%);
        margin-right: 10px;
    }

    .name {
        padding: 0;
        margin: 0;
        transition: opacity 0.2s ease-in-out;
        align-items: center;
        display: flex;
        white-space: nowrap;
        overflow: hidden;
        color: black;

        .text {
            text-overflow: ellipsis;
            width: 100%;
            overflow: hidden;
        }
    }

    .actions {
        .flex-row;
        justify-content: flex-end;
        min-height: 40px;
        position: relative;
        margin: 0;
        margin-left: auto;
        z-index: 4;

        .face {
            opacity: 0.5;
            margin-right: 3px;
        }
    }
}
</style>
